import ViewHome from "./ViewHome.vue";
import ViewScopingTitlePage from "./ViewScopingTitlepage.vue";
import ViewScopingTitlePagePeople from "./ViewScopingTitlePagePeople.vue";
import ViewScopingPicot from "./ViewScopingPicot.vue";
import ViewScopingSearchStrings from "./ViewScopingSearchStrings.vue";

import ViewScopingDataExtraction from "./ViewScopingDataExtraction.vue";
import ViewScopingAssessmentOfTheRiskOfBias from "./ViewScopingAssessmentOfTheRiskOfBias.vue";
import ViewScopingAnalysisOfData from "./ViewScopingAnalysisOfData.vue";
//import ViewScopingAnalysisApproach from "./ViewScopingAnalysisApproach.vue";
import ViewScopingSubgroupAndSensitivityAnalysis from "./ViewScopingSubgroupAndSensitivityAnalysis.vue";
import ViewScopingOutput from "./ViewScopingOutput.vue";
import ViewScopingDataExtractionReport from "./ViewScopingDataExtractionReport.vue";

//not share state with REVIEW-WIZARD
//ViewScopingMeasurementOfEffect?

//TODO diff contents in the future
import ViewScopingResearchPlan from "./ViewScopingResearchPlan.vue";
//Shared components from REVIEW-WIZARD
import ViewAcknowledgement from "../methods-wizard/ViewAcknowledgement.vue";
import ViewMethodContributions from "../methods-wizard/ViewMethodContributions.vue";
import ViewMethodDealingWithMissingData from "../methods-wizard/ViewMethodDealingWithMissingData.vue";
import ViewMethodSearchStrategy from "../methods-wizard/ViewMethodSearchStrategy.vue";
import ViewScopingScreening from "../methods-wizard/ViewMethodScreening.vue";
import ViewMethodStudyInformation from "../methods-wizard/ViewMethodStudyInformation.vue";

import ViewScopingIntroduction from "./ViewScopingIntroduction.vue";

const getMenu = () => [
	{
		header: true,
		title: "PLANNING",
		hiddenOnCollapse: true
	},
	{
		title: "Title Page",
		icon: "pi pi-file",
		href: `/planning/titlepage`
	},
	{
		title: "People",
		icon: "pi pi-file",
		href: `/planning/people`
	},
	{
		title: "Scoping Plan",
		icon: "pi pi-list",
		href: `/planning/rs-plan`
	},
	{
		header: true,
		title: "INTRODUCTION",
		hiddenOnCollapse: true
	},
	{
		title: "Introduction",
		icon: "pi pi-pencil",
		href: `/introduction`
	},
	{
		header: true,
		title: "METHODS",
		hiddenOnCollapse: true
	},
	{
		title: "Eligibility Criteria (PCCTT)",
		icon: "pi pi-file",
		href: `/method/picot`
	},
	{
		title: "Search Strategy",
		icon: "pi pi-search",
		href: `/method/search-strategy`
	},
	{
		title: "Search Strings",
		icon: "pi pi-search",
		href: `/method/search-str`
	},
	{
		title: "Study Selection and Screening",
		icon: "pi pi-check",
		href: `/method/screening`
	},
	{
		title: "Critical Appraisal",
		icon: "pi pi-exclamation-circle",
		href: `/method/critical-appraisal`
	},
	{
		title: "Data Extraction",
		icon: "pi pi-upload",
		href: `/method/data-extraction`
	},
	{
		title: "Analysis of Data",
		icon: "pi pi-chart-bar",
		href: `/method/analysis-of-data`
	},
	{
		title: "Dealing with Missing Data",
		icon: "pi pi-question",
		href: `/method/missing-data`
	},
	{
		title: "Subgroup Analysis",
		icon: "pi pi-chart-line",
		href: `/method/subgroup-sensitivity-analysis`
	},
	{
		title: "Study Information",
		icon: "pi pi-file",
		href: `/method/study-information`
	},
	{
		title: "Contributions",
		icon: "pi pi-chart-line",
		href: `/method/contributions`
	},
	{
		title: "Acknowledgement",
		icon: "pi pi-file",
		href: `/planning/ac-view`
	},
	{
		header: true,
		title: "REPORTS",
		hiddenOnCollapse: true
	},
	{
		title: "Research Plan",
		icon: "pi pi-list",
		href: `/reports/rs-plan`
	},
	{
		title: "Methods Section",
		icon: "pi pi-download",
		href: `/reports/output`
	},
	{
		title: "Data Extraction",
		icon: "pi pi-upload",
		href: `/reports/de-view`
	}
];
const routes = [
	{ name: "home", path: "", component: ViewHome },
	{
		name: "titlepage",
		path: "/planning/titlepage",
		component: ViewScopingTitlePage
	},
	{
		name: "people",
		path: "/planning/people",
		component: ViewScopingTitlePagePeople
	},
	{
		name: "rs-plan",
		path: "/planning/rs-plan",
		component: ViewScopingResearchPlan
	},
	{
		name: "introduction",
		path: "/introduction",
		component: ViewScopingIntroduction
	},
	{
		name: "picot",
		path: "/method/picot",
		component: ViewScopingPicot
	},
	{
		name: "search-strategy",
		path: "/method/search-strategy",
		component: ViewMethodSearchStrategy
	},
	{
		name: "search-str",
		path: "/method/search-str",
		component: ViewScopingSearchStrings
	},
	{
		path: "/method/screening",
		component: ViewScopingScreening
	},
	{
		path: "/method/critical-appraisal", //Assessment-Of-The-RiskOfBias
		component: ViewScopingAssessmentOfTheRiskOfBias
	},
	{
		path: "/method/data-extraction",
		component: ViewScopingDataExtraction
	},
	{
		path: "/method/analysis-of-data",
		component: ViewScopingAnalysisOfData
	},
	{
		path: "/method/missing-data",
		component: ViewMethodDealingWithMissingData
	},
	{
		path: "/method/subgroup-sensitivity-analysis",
		component: ViewScopingSubgroupAndSensitivityAnalysis
	},
	{
		name: "study-information",
		path: "/method/study-information",
		component: ViewMethodStudyInformation
	},
	{
		path: "/method/contributions",
		component: ViewMethodContributions
	},
	{
		name: "ac-view",
		path: "/planning/ac-view",
		component: ViewAcknowledgement
	},
	{
		name: "rs-plan",
		path: "/reports/rs-plan",
		component: ViewScopingResearchPlan
	},
	{
		name: "output",
		path: "/reports/output",
		component: ViewScopingOutput
	},
	{
		name: "de-view",
		path: "/reports/de-view",
		component: ViewScopingDataExtractionReport
	}
];

export { routes, getMenu };
